import { twMerge } from "tailwind-merge"
import Skeleton from "../../Skeleton"

const SkeletonCard = () => {
  return (
    <div className={twMerge("w-full rounded-lg opacity-50")}>
     <div className="flex items-start gap-2 p-4 bg-white-100 rounded-t-lg items-center ">
        <div className="w-[24px] h-[24px] rounded-full flex ">
        <Skeleton circle />
        </div>
        <Skeleton width={115}/>
      </div>
      <div className="bg-blue-300 flex flex-col gap-3 rounded-b-lg p-4">
        <div>
          <p className="text-xs break-words mb-1"><Skeleton /></p>
          <span><Skeleton/></span>
        </div>
        <div className="flex gap-2 items-center">
        <div className={twMerge("flex size-4 items-center justify-center rounded-full shrink-0")}>
         <Skeleton circle/>
        </div>
        <Skeleton/>
        </div>
      </div>
    </div>
  )
}

export default SkeletonCard